var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#fff","height":"100%"}},[_c('Header',{attrs:{"title":_vm.topName,"is-nav":true}}),_c('div',{staticClass:"protocolModal",domProps:{"innerHTML":_vm._s(_vm.viewAgreement)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }